document.addEventListener('DOMContentLoaded', function() {

  const form = document.getElementById('medical-questionnaire-form');
  const steps = document.querySelectorAll('.q-step');
  const progressBar = document.getElementById('q-progress-bar');
  const currentStepSpan = document.getElementById('q-current-step');
  const loopOutContainer = document.getElementById('q-loop-out');
  const totalSteps = steps.length;

  let historyStack = [];
  let currentStepId = 1;

  updateProgress(1);

  document.querySelectorAll('.q-btn--next').forEach(btn => {
    btn.addEventListener('click', () => {
      const nextStepId = parseInt(btn.dataset.next);
      const logicType = btn.dataset.logic;

      if (validateCurrentStep(currentStepId)) {
        if (logicType === 'check-risk') {
          handleRiskLogic(nextStepId);
        } else {
          goToStep(nextStepId);
        }
      }
    });
  });

  document.querySelectorAll('.q-btn--back').forEach(btn => {
    btn.addEventListener('click', goBack);
  });

  document.querySelectorAll('.q-btn--option').forEach(btn => {
    btn.addEventListener('click', function () {
      if (this.closest('#q-loop-out')) return;

      const parent = this.closest('.q-step');
      parent.querySelectorAll('.q-btn--option').forEach(b => b.classList.remove('selected'));
      this.classList.add('selected');

      const hiddenInput = parent.querySelector('input[type="hidden"]');
      if (hiddenInput) hiddenInput.value = this.dataset.value;

      if (this.dataset.next === 'loopout') {
        triggerLoopOut();
        return;
      }

      const nextId = parseInt(this.dataset.next);
      if (nextId) {
        setTimeout(() => goToStep(nextId), 200);
      }
    });
  });

  function goToStep(stepId) {
    document.querySelector(`.q-step[data-step="${currentStepId}"]`).classList.remove('active');
    historyStack.push(currentStepId);
    document.querySelector(`.q-step[data-step="${stepId}"]`).classList.add('active');
    currentStepId = stepId;
    updateProgress(stepId);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  function goBack() {
    if (!historyStack.length) return;
    const prev = historyStack.pop();
    document.querySelector(`.q-step[data-step="${currentStepId}"]`).classList.remove('active');
    document.querySelector(`.q-step[data-step="${prev}"]`).classList.add('active');
    currentStepId = prev;
    updateProgress(prev);
  }

function updateProgress(stepId) {
  const pct = ((stepId - 1) / (totalSteps - 1)) * 100;
  progressBar.style.width = pct + '%';
  currentStepSpan.textContent = stepId;
}


  function triggerLoopOut() {
    form.style.display = 'none';
    document.querySelector('.q-progress-container').style.display = 'none';
    loopOutContainer.classList.remove('hidden');
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  function validateCurrentStep(stepId) {
    const stepEl = document.querySelector(`.q-step[data-step="${stepId}"]`);
    let valid = true;

    stepEl.querySelectorAll('input[required], textarea[required]').forEach(input => {
      if (!input.value.trim()) {
        valid = false;
        input.classList.add('error');
        input.addEventListener('input', () => input.classList.remove('error'), { once: true });
      }
    });

    const checklist = stepEl.querySelector('.q-checklist-container');
    if (checklist && !checklist.querySelector('input:checked')) {
      alert('Please select at least one option.');
      valid = false;
    }

    return valid;
  }

  function handleRiskLogic(nextStepId) {
    const stepEl = document.querySelector(`.q-step[data-step="${currentStepId}"]`);
    const risks = stepEl.querySelectorAll('.q-risk-trigger:checked');

    if (risks.length > 0) {
      triggerLoopOut();
    } else {
      goToStep(nextStepId);
    }
  }

  // 🔙 Loop Out Back Button Logic
  const loopBackBtn = document.getElementById('q-loop-back');
  if (loopBackBtn) {
    loopBackBtn.addEventListener('click', () => {
      loopOutContainer.classList.add('hidden');
      form.style.display = '';
      document.querySelector('.q-progress-container').style.display = '';

      const lastStep = historyStack.pop() || 1;
      document.querySelectorAll('.q-step').forEach(s => s.classList.remove('active'));
      document.querySelector(`.q-step[data-step="${lastStep}"]`).classList.add('active');

      currentStepId = lastStep;
      updateProgress(lastStep);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

});
